let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("WDgO4")).then(() => parcelRequire('3NpHq'));